import { put, getContext } from 'redux-saga/effects'
import importer from 'common/importer'
const { getLoyaltyAchievementBadges } = importer('GraphQL/Queries')
const PublicContentActions = importer('Stores/PublicContent/Actions')
import i18next from 'i18next';
export default function * main () {
  try {
    const isSpanish = i18next.language === 'es-MX'
    yield put(PublicContentActions.getLoyaltyAchievementBadgesLoading())
    const apolloClient = yield getContext('client')
    const query = getLoyaltyAchievementBadges
    const {data, error} = yield apolloClient.query({query, variables: {isSpanish : isSpanish }})
    if (error) { throw error }
    const list = data.salesforce_bll_achievement_badge__c
    yield put(PublicContentActions.getLoyaltyAchievementBadgesSuccess(list))
  } catch (error) {
    yield put(PublicContentActions.getLoyaltyAchievementBadgesFailure(error))
  }
}
